(function(){
  if (window.__stickeredInstallUpsellAddOnlyReady) return;
  window.__stickeredInstallUpsellAddOnlyReady = true;

  function refreshCartUi() {
    document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
    document.dispatchEvent(new CustomEvent('cart:updated', { bubbles: true }));
    document.dispatchEvent(new CustomEvent('ajaxCart:refresh', { bubbles: true }));
  }

  function addVariant(variantId) {
    return fetch('/cart/add.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      body: JSON.stringify({
        id: Number(variantId),
        quantity: 1
      })
    }).then(function(response){
      if (!response.ok) throw new Error('Unable to add installation item');
      return response.json();
    });
  }

  function fetchCart() {
    return fetch('/cart.js', {
      credentials: 'same-origin',
      headers: { 'Accept': 'application/json' }
    }).then(function(response){
      if (!response.ok) throw new Error('Unable to fetch cart');
      return response.json();
    });
  }

  function removeVariant(variantId) {
    return fetchCart().then(function(cart){
      var item = (cart.items || []).filter(function(cartItem){
        return String(cartItem.variant_id) === String(variantId);
      })[0];

      if (!item) return cart;

      return fetch('/cart/change.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        body: JSON.stringify({
          id: item.key,
          quantity: 0
        })
      }).then(function(response){
        if (!response.ok) throw new Error('Unable to remove installation item');
        return response.json();
      });
    });
  }

  function bindButton(button) {
    if (!button || button.dataset.stkInstallBound === 'true') return;
    button.dataset.stkInstallBound = 'true';

    var label = button.querySelector('[data-stk-install-add-text]');
    var idleText = label ? label.textContent : '+ Add';

    button.addEventListener('click', function(event){
      event.preventDefault();
      event.stopPropagation();
      if (event.stopImmediatePropagation) event.stopImmediatePropagation();

      if (button.disabled) return;

      var variantId = button.getAttribute('data-variant-id');
      if (!variantId) return;

      var isAdded = button.dataset.state === 'added';

      button.disabled = true;
      if (label) label.textContent = isAdded ? 'Removing...' : 'Adding...';

      (isAdded ? removeVariant(variantId) : addVariant(variantId))
      .then(function(){
        button.dataset.state = isAdded ? 'idle' : 'added';
        button.classList.toggle('is-added', !isAdded);
        button.disabled = false;
        if (label) label.textContent = isAdded ? '+ Add' : 'Remove';
        refreshCartUi();
      })
      .catch(function(error){
        if (label) label.textContent = 'Try again';
        button.disabled = false;
        if (window.console && console.error) {
          console.error('[Stickered install upsell]', error);
        }
        setTimeout(function(){
          if (!button.disabled && label) label.textContent = button.dataset.state === 'added' ? 'Remove' : idleText;
        }, 1800);
      });
    });
  }

  function initInstallUpsells() {
    document.querySelectorAll('[data-stk-install-add]').forEach(bindButton);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initInstallUpsells);
  } else {
    initInstallUpsells();
  }

  if (window.MutationObserver) {
    var queued = false;
    var observer = new MutationObserver(function(){
      if (queued) return;
      queued = true;
      setTimeout(function(){
        queued = false;
        initInstallUpsells();
      }, 120);
    });

    observer.observe(document.documentElement, { childList: true, subtree: true });
    setTimeout(function(){ observer.disconnect(); }, 30000);
  }
})();
